import React from 'react'
import PropTypes from 'prop-types'
import { DISPLAY } from 'constants/display'
import { stopTypes } from 'constants/facilities'
import { formatDate } from '../../../utils/schedule'
import { DeprecatedFCFSButton } from '../Buttons/DeprecatedFCFSButton'
import { DeprecatedTimeButtonList } from '../Buttons/DeprecatedTimeButtonList'

/**
 * @deprecated Please delete this file when mpNewSchedulerPage got turned on in prod
 */
export const Unconfirmed = ({ apptType, stop, stopType }) => {
  const {
    appointmentReference,
    bol,
    endAtTime,
    po,
    shipperName,
    startAtDate,
    startAtTime,
    stopId,
  } = stop
  return (
    <div className='pv5' key={stopId}>
      <div className='pv4'>
        <b>
          {stopTypes[stopType]} {formatDate(startAtDate)}
        </b>
        <div>Shipper: {shipperName}</div>
        <div>PO: {po || DISPLAY.na}</div>
        <div>BOL: {bol || DISPLAY.na}</div>
        <div>Appt #: {appointmentReference || DISPLAY.na}</div>
      </div>
      <div className='pv4'>
        {(apptType === 'appointment' || !apptType) && (
          <DeprecatedTimeButtonList stopType={stopType} stop={stop} />
        )}
        {(apptType === 'fcfs' || apptType === 'range') && (
          <>
            <div className='pv4'>
              Will {startAtTime} - {endAtTime} work?
            </div>
            <div className='ph2'>
              <DeprecatedFCFSButton stop={stop} />
            </div>
            <span>Please reply to the email we sent you if these hours do not work</span>
          </>
        )}
      </div>
    </div>
  )
}

Unconfirmed.propTypes = {
  stop: PropTypes.shape({}).isRequired,
  stopType: PropTypes.string.isRequired,
  apptType: PropTypes.string.isRequired,
}
